"use client"

import { ACTIVITY_CID_EXPIRE_TIME } from "@/constants/global";
import { StorageKey } from "@/constants/storage";
import { useEffect } from "react";

const sequenceKeys = ['mz_ca', 'mz_sp', 'mz_sb']

export function extractQueryParams(url: string) {
  const urlObj = new URL(url);
  const searchParams = new URLSearchParams(urlObj.search);
  const params: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
}

function generateCampaignCid(urlParams: Record<string, string>) {
  const campaignCids: string[] = []
  sequenceKeys.forEach((key: string) => {
    if (urlParams[key]) {
      campaignCids.push(decodeURIComponent(urlParams[key]).trim())
    }
  })
  return campaignCids.join('_')
}

function storeValueWithExpiration(key: string, value: string, duration: number) {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + duration);
  localStorage.setItem(key, JSON.stringify({
    [key]: value,
    [`${key}_expiry`]: expiryDate.toISOString()
  }))
}

const checkExpiry = (key: string) => {
  const localStorageValue = localStorage.getItem(key)
  if (localStorageValue) {
    const expiry = JSON.parse(localStorageValue)[`${key}_expiry`];
    return new Date() > new Date(expiry);
  }
};

const checkRemoveExpiredValue = (key: string) => {
  // 清除过期的数据
  if (checkExpiry(key)) {
    localStorage.removeItem(key);
  }
}

const hasCommonKeys = (arr1: string[], arr2: string[]) => {
  const set1 = new Set(arr1);
  for (const item of arr2) {
    if (set1.has(item)) {
      return true;
    }
  }
  return false;
}

export default function useStoreUTMActivityIdAndCid() {
  useEffect(() => {
    const urlParameters = extractQueryParams(window.location.href)
    const keys = Object.keys(urlParameters)
    const { UTM_ACTIVITY_ID, CAMPAIGN_CID } = StorageKey

    if (typeof window !== 'undefined') {
      if (keys.includes(UTM_ACTIVITY_ID)) {
        storeValueWithExpiration(UTM_ACTIVITY_ID, urlParameters[UTM_ACTIVITY_ID], ACTIVITY_CID_EXPIRE_TIME)
      } else {
        checkRemoveExpiredValue(UTM_ACTIVITY_ID)
      }
      if (hasCommonKeys(sequenceKeys, keys)) {
        storeValueWithExpiration(CAMPAIGN_CID, generateCampaignCid(urlParameters), ACTIVITY_CID_EXPIRE_TIME)
      } else {
        checkRemoveExpiredValue(CAMPAIGN_CID)
      }
    }
  }, [])
}


export function fetchUTMActivityIdAndCid() {
  const storedCampaignCId = localStorage.getItem(StorageKey.CAMPAIGN_CID)
  const storedActivityId = localStorage.getItem(StorageKey.UTM_ACTIVITY_ID)
  return {
    campaignCid: storedCampaignCId ? JSON.parse(storedCampaignCId)[StorageKey.CAMPAIGN_CID] : null,
    activityid: storedActivityId ? JSON.parse(storedActivityId)[StorageKey.UTM_ACTIVITY_ID] : null,
  }
}
